@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

.earningsChartRoot {
  @include border-radius-r2;
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  border: 1px solid var(--border-soft);
  margin-bottom: 32px;
}

.title {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 20px;
  border-bottom: 1px solid var(--border-soft);
  min-height: 1em;
  box-sizing: content-box;
  @include typography-v2-body-base;
}

.content {
  padding: 12px 20px;
}

.chartWrapper {
  margin-bottom: 20px;
}
